import {
  formatCurrency,
  formatCurrencyFromCents,
  formatDate,
  formatNumber,
  formatPercent,
  type FormatCurrencyOptions,
} from "@donoor/utils";
import { LOCALE_INTL, type Langue } from "~/utils/langue";

/**
 * Formateurs (montants, dates, nombres) dans la langue de la page.
 *
 * Les helpers de @donoor/utils formatent en fr-FR par défaut. Dans un
 * composant affiché en anglais, passer par ce composable : « 1 234,50 € »
 * devient « €1,234.50 », « 12 octobre 2026 » devient « 12 October 2026 ».
 */
export function useFormatLangue() {
  const { locale } = useI18n();
  const localeIntl = computed(() => LOCALE_INTL[locale.value as Langue] ?? LOCALE_INTL.fr);

  return {
    localeIntl,
    formatCurrency: (montant: Parameters<typeof formatCurrency>[0], options?: FormatCurrencyOptions) =>
      formatCurrency(montant, { ...options, locale: options?.locale ?? localeIntl.value }),
    formatCurrencyFromCents: (
      centimes: Parameters<typeof formatCurrencyFromCents>[0],
      options?: FormatCurrencyOptions,
    ) => formatCurrencyFromCents(centimes, { ...options, locale: options?.locale ?? localeIntl.value }),
    formatNumber: (n: Parameters<typeof formatNumber>[0], options?: Parameters<typeof formatNumber>[1]) =>
      formatNumber(n, { ...(options ?? {}), locale: localeIntl.value } as Parameters<typeof formatNumber>[1]),
    formatPercent: (n: Parameters<typeof formatPercent>[0], options?: Parameters<typeof formatPercent>[1]) =>
      formatPercent(n, { ...(options ?? {}), locale: localeIntl.value } as Parameters<typeof formatPercent>[1]),
    formatDate: (d: Parameters<typeof formatDate>[0], options?: Parameters<typeof formatDate>[1]) =>
      formatDate(d, { ...(options ?? {}), locale: localeIntl.value } as Parameters<typeof formatDate>[1]),
  };
}
